<!-- <h3 class="text-md-left" > All Publications</h3> -->
<!-- <h3 class="text-xs-center text-md-left">Research</h3> -->


<app-pub-wrapper [pub_group]=getPubs()></app-pub-wrapper>
